import { useState, useEffect } from "react";

/**
 * Debounces a value by the given delay (ms).
 * Returns a debounced value that only updates after delay has passed
 * without further changes.
 *
 * @param value - The input value to debounce
 * @param delay - Delay in milliseconds (default: 300ms)
 */
export function useDebounce<T>(value: T, delay: number = 300): T {
	const [debouncedValue, setDebouncedValue] = useState<T>(value);

	useEffect(() => {
		const handler = setTimeout(() => {
			setDebouncedValue(value);
		}, delay);

		return () => {
			clearTimeout(handler);
		};
	}, [value, delay]);

	return debouncedValue;
}
